// frontend/src/services/authService.js
import api from './api';

class AuthService {
  async login(email, password) {
    try {
      // Use the named method from api.js
      const response = await api.login(email, password);
      return response;
    } catch (error) {
      throw error.response?.data || error || { error: 'Login failed' };
    }
  }

  async register(userData) {
    try {
      const response = await api.register(userData);
      return response;
    } catch (error) {
      throw error.response?.data || error || { error: 'Registration failed' };
    }
  }

  async logout() {
    try {
      await api.logout();
    } catch (error) {
      console.error('Logout error:', error);
    }
  }

  async getProfile() {
    try {
      // api.getProfile already returns response.data
      return await api.getProfile();  
    } catch (error) {
      throw error.response?.data || error || { error: 'Failed to get profile' };
    }
  }

  async refreshToken(refreshToken) {
    try {
      // api.js has rotateRefreshToken, not a generic post
      const response = await api.rotateRefreshToken(refreshToken);
      return response;
    } catch (error) {
      throw error.response?.data || error || { error: 'Failed to refresh token' };
    }
  }
}

export default new AuthService();